import { Component, Input } from '@angular/core'
import { FormFieldComponent } from '../form-field/form-field.component'

@Component({
  selector: 'bdg-password-field',
  templateUrl: './password-field.component.html',
})
export class PasswordFieldComponent extends FormFieldComponent {
  hide = true
  @Input()
  id: string

  constructor() {
    super()
  }
}
